import { makeAutoObservable } from "mobx";

class ErrorStore {
  constructor() {
    makeAutoObservable(this);
  }
  status = "success";
  message = "";
  loading = false;
  error_message = "";
  message_placement = "topRight";
  error = false;
  info = false;
  panic = false;
  warning = false;
  items_request = "";
  better_experience = "";

  setMessage = (message) => {
    this.message = message;
  };

  handlerErrors = (err) => {
    console.log(err);
    this.status = "error";
    this.loading = false;
    this.setMessage(err.message);
    this.setItemsRequest("");
  };

  handlerCussess = (message) => {
    this.status = "success";
    this.message = message;
    this.loading = false;
  };

  setLoading = (loading) => {
    this.loading = loading;
  };

  setItemsRequest = (message) => {
    setTimeout(() => {
      this.items_request = message;
    }, 5000);
  };

  setBetterExperience = () => {
    this.better_experience =
      "For a better experience, we recommend using this app on a desktop browser.";
  };

  clearBetterExperience = () => {
    this.better_experience = "";
  };

  setStatus = (status) => {
    this.status = status;
  };

  setMessagePlacement = (value) => {
    this.message_placement = value;
  };

  setInfo = (value) => {
    this.info = value;
  };

  setError = (value) => {
    this.error = value;
  };

  setWarning = (value) => {
    this.warning = value;
  };

  setPanic = (value) => {
    this.panic = value;
  };
}

export default ErrorStore;
